import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as CloseIcon } from 'assets/close-icon.svg';
import { ReactComponent as SuccessIcon } from 'assets/new-succes-icon.svg';
import i18nContext from 'components/i18n-context';
import { getErrorMessageForAlert } from 'services/utils';
import Alert from 'uikit/Alert/Alert';
import Button from 'uikit/Button/Button';
import './PopUpScheme.scss';

const PopUpForApprovalTransactionConfirmationScheme = ({
  onClose,
  onConfirm,
  isLoading,
  isSuccess,
  isForApprovalTransactionEdit,
  error
}) => {
  const i18n = useContext(i18nContext);

  return (
    <div className={'scheme-wrapper for-approval-confirmation'}>
      <div className={'scheme-header'}>
        <p className={'title'}>
          {i18n.getMessage(isForApprovalTransactionEdit ? 'popUp.editPaymentTitle' : 'popUp.savePaymentTitle')}
        </p>
        <CloseIcon className={'scheme-close-icon'} onClick={onClose} />
      </div>

      {isSuccess ? (
        <div className={'scheme-content-success'}>
          <SuccessIcon />
          <p className={'primary-text'}>
            {i18n.getMessage(isForApprovalTransactionEdit ? 'popUp.editPaymentSuccess' : 'popUp.savePaymentSuccess')}
          </p>
          <p className={'secondary-text'}>{i18n.getMessage('popUp.storedPaymentLocation')}</p>
        </div>
      ) : (
        <>
          <div className={'scheme-content'}>
            <p className={'secondary-text'}>
              {i18n.getMessage(
                isForApprovalTransactionEdit ? 'popUp.editPaymentDescription' : 'popUp.savePaymentDescription'
              )}
            </p>
          </div>

          {error && (
            <Alert
              type={'warning'}
              className={'for-approval-confirmation-error-alert'}
              message={getErrorMessageForAlert(i18n, error)}
            />
          )}

          <div className={'scheme-footer'}>
            <Button
              className={'cancel-button'}
              type={'outline'}
              size={'large'}
              isLoading={isLoading}
              onClick={onClose}
              isDisabled={isLoading}
            >
              {i18n.getMessage('button.no')}
            </Button>

            <Button
              className={'confirm-button'}
              type={'primary'}
              size={'large'}
              isLoading={isLoading}
              onClick={onConfirm}
              isDisabled={isLoading}
            >
              {i18n.getMessage('button.yes')}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

PopUpForApprovalTransactionConfirmationScheme.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isSuccess: PropTypes.bool,
  isForApprovalTransactionEdit: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
};

export default PopUpForApprovalTransactionConfirmationScheme;
